module.exports = __webpack_public_path__ + "img/carshinaused_18.1f44154a.jpg";